import React, { useState } from 'react';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';
// Import shared components
import arrayMutators from 'final-form-arrays';
// Import modules from this directory
import css from './EditListingBrandPremierForm.module.css';
import { useIntl } from 'react-intl';
import RenderUserSubscriptionMaybe from '../../EditListingTalentPlusPanel/RenderUserSubscriptionMaybe/RenderUserSubscriptionMaybe';
import { BrandSubscriptionPriceModal, Button, Form } from '../../../../../components';
import { isArrayLength } from '../../../../../util/genericHelpers';

export const EditListingBrandPremierForm = props => (
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    render={formRenderProps => {
      const {
        className,
        handleSubmit,
        fetchErrors,
        values,
        form,
        subscriptionMaybe,
        lookupKeys,
      } = formRenderProps;
      const classes = classNames(css.root, className);
      const { updateListingError } = fetchErrors || {};
      const [isPlanModalOpen, setPlanModalOpen] = useState(false);
      const [selectedSubscription, setSelectedSubscription] = useState(false);
      const intl = useIntl();

      return (
        <Form onSubmit={handleSubmit} className={classes}>
          {updateListingError ? (
            <p className={css.error}>
              {intl.formatMessage({
                id: 'EditListingBrandPremierForm.updateFailed',
              })}
            </p>
          ) : null}

          <div className={css.subcriptionPlanButton}>
            <Button type="button" onClick={() => setPlanModalOpen(!isPlanModalOpen)}>
              {intl.formatMessage({
                id: 'EditListingBrandPremierForm.createSubscriptionPlan',
              })}
            </Button>
          </div>

          {isArrayLength(subscriptionMaybe) ? (
            <RenderUserSubscriptionMaybe
              subscriptions={subscriptionMaybe}
              lookupKeys={lookupKeys}
              onEdit={subscription => {
                setPlanModalOpen(true);
                setSelectedSubscription(subscription);
              }}
              isEditListingPage={true}
            />
          ) : null}

          <BrandSubscriptionPriceModal
            isOpen={isPlanModalOpen}
            onClose={() => setPlanModalOpen(false)}
            values={values}
            form={form}
            selectedSubscription={selectedSubscription}
            intl={intl}
            isBrandPremier
          />
        </Form>
      );
    }}
  />
);

export default EditListingBrandPremierForm;
